import * as Yup from 'yup';

export default Yup.object().shape({
  id: Yup.number(),
  clientId: Yup.number().required(),
  name: Yup.string().max(500, 'Please use less than 500 characters'),
  projectNumber: Yup.string().required('Project# is required').max(20, 'Please use less than 20 characters'),
  description: Yup.string().max(5000, 'Please use less than 5000 characters'),
  contractorIds: Yup.array().nullable()
});